export default {
  AUTOCOMPLETE: Symbol('AUTOCOMPLETE'),
  INPUT: Symbol('INPUT'),
  RADIO: Symbol('RADIO'),
  MOCK: Symbol('MOCK'),
};
